import dayjs from "../../../utils/dayjs";

export function groupBillsByDocumentDate(bills) {
  const groupsMap = new Map();

  bills.forEach(bill => {
    const key = bill.exportedDate
      ? dayjs(bill.exportedDate).startOf("day").valueOf()
      : "none";

    if (!groupsMap.has(key)) {
      groupsMap.set(key, {
        key,
        date: bill.exportedDate ? dayjs(bill.exportedDate) : null,
        billIds: [],
        bills: [],
      });
    }

    const group = groupsMap.get(key);
    group.billIds.push(bill._id);
    group.bills.push(bill);
  });

  return Array.from(groupsMap.values());
}
